export default __webpack_public_path__ + "static/media/campusmap.2a146bbb.png";